import { pageLoaderTypes } from './pageLoaderTypeConsts';

// Step route names
const routes = {
  ACCOUNT: 'account',
  ACTIVITY: 'activity',
  ADDRESS: 'address',
  ALREADY_HAS_ACTIVE_ACCOUNT: 'already_has_active_account',
  DECLINE: 'decline',
  DOB_FIELD_PAGE: 'date_of_birth',
  EMAIL: 'email',
  EMBEDDED_ACCEPT_DISMISS: 'accept_dismiss',
  NAME: 'name',
  PASSWORD: 'password',
  PENDING: 'pending',
  PERSONAL_INFO: 'personal_info',
  PHONE_FIELD_PAGE: 'phone',
  PRODUCT_PICKER: 'product_picker',
  REVIEW_ADDRESS: 'review_address',
  REVIEW_INTRO: 'review_intro',
  REVIEW_DOB_FIELD_PAGE: 'review_date_of_birth',
  REVIEW_NAME: 'review_name',
  REVIEW_SSN: 'review_social_security',
  SSN_FIELD_PAGE: 'social_security',
  SUCCESS: 'success',
  TOS_PAGE: 'terms_of_service',
  VERIFY_PHONE: 'verify_phone',
  VERIFY_SCAN_ID: 'verify_scan_id',
  PREFILL_CONFIRMATION: 'prefill_confirmation',
};

const p2pRoutes = {
  P2P_ACCOUNT: 'p2p_account',
  P2P_PERSONAL_INFO: 'p2p_personal_info',
  P2P_IDENTITY: 'p2p_identity',
  P2P_ACTIVITY: 'p2p_activity',
  P2P_SUCCESS: 'p2p_success',
};

export const cbRewardsRoutes = {
  CB_REWARDS_SUCCESS: '/cb_rewards_success',
  CB_SUCCESS_NO_REWARDS: '/cb_success_no_rewards',
  CB_PENDING_REWARDS_SUCCESS: '/cb_pending_rewards_success',
};

export const postEnrollmentRoutePaths = [
  ...Object.values(cbRewardsRoutes),
  `/${routes.SUCCESS}`,
  `/${routes.PENDING}`,
  `/${routes.DECLINE}`,
  `/${routes.EMBEDDED_ACCEPT_DISMISS}`,
  `/${routes.VERIFY_SCAN_ID}`,
  `/${routes.VERIFY_PHONE}`,
  `/${routes.ALREADY_HAS_ACTIVE_ACCOUNT}`,
];

export const prefillDataEditRoutePaths = [
  `/${routes.DOB_FIELD_PAGE}`,
  `/${routes.ADDRESS}`,
];

export default routes;

/**
 * Route Object format:
 * name: String name of the route
 * path: String hash router path to route, prefixed with /
 * pageComponentFileName: Page component file name
 */

export const P2P_ACCOUNT_ROUTE = {
  name: p2pRoutes.P2P_ACCOUNT,
  path: `/account`,
  runArkoseOnSubmit: true,
};

export const P2P_PERSONAL_INFO_ROUTE = {
  name: p2pRoutes.P2P_PERSONAL_INFO,
  path: `/personal_info`,
  runArkoseOnSubmit: true,
};

export const P2P_IDENTITY_ROUTE = {
  name: p2pRoutes.P2P_IDENTITY,
  path: `/identify`, // Renamed from identity to avoid triggering KYC in embedded.
  runArkoseOnSubmit: true,
};

export const P2P_ACTIVITY_ROUTE = {
  name: p2pRoutes.P2P_ACTIVITY,
  path: `/activity`,
  isSubmitPage: true,
  runArkoseOnSubmit: true,
};

export const ACCOUNT_ROUTE = {
  name: routes.ACCOUNT,
  path: `/${routes.ACCOUNT}`,
  runArkoseOnSubmit: true,
};

export const ADDRESS_ROUTE = {
  name: routes.ADDRESS,
  path: `/${routes.ADDRESS}`,
  successAnimation: pageLoaderTypes.SECURITY_ANIMATION,
};

export const ACTIVITY_ROUTE = {
  name: routes.ACTIVITY,
  path: `/${routes.ACTIVITY}`,
  successAnimation: pageLoaderTypes.SECURITY_ANIMATION,
};

export const DATE_OF_BIRTH_ROUTE = {
  name: routes.DOB_FIELD_PAGE,
  path: `/${routes.DOB_FIELD_PAGE}`,
};

export const PASSWORD_ROUTE = {
  name: routes.PASSWORD,
  path: `/${routes.PASSWORD}`,
  isPasswordPage: true,
};

export const PHONE_ROUTE = {
  name: routes.PHONE_FIELD_PAGE,
  path: `/${routes.PHONE_FIELD_PAGE}`,
  runArkoseOnSubmit: true,
};

export const PRODUCT_PICKER_ROUTE = {
  name: routes.PRODUCT_PICKER,
  path: `/${routes.PRODUCT_PICKER}`,
};

export const VERIFY_PHONE_ROUTE = {
  name: routes.VERIFY_PHONE,
  path: `/${routes.VERIFY_PHONE}`,
};

export const VERIFY_SCAN_ID_ROUTE = {
  name: routes.VERIFY_SCAN_ID,
  path: `/${routes.VERIFY_SCAN_ID}`,
};

export const SSN_ROUTE = {
  name: routes.SSN_FIELD_PAGE,
  path: `/${routes.SSN_FIELD_PAGE}`,
  runArkoseOnSubmit: true,
  successAnimation: pageLoaderTypes.SECURITY_ANIMATION,
};

export const TOS_PAGE_ROUTE = {
  name: routes.TOS_PAGE,
  path: `/${routes.TOS_PAGE}`,
  isSubmitPage: true,
  runArkoseOnSubmit: true,
};

/** Post Enrollment Page route consts */

export const DECLINE_ROUTE = {
  name: routes.DECLINE,
  path: `/${routes.DECLINE}`,
};

export const PENDING_ROUTE = {
  name: routes.PENDING,
  path: `/${routes.PENDING}`,
};

export const SUCCESS_ROUTE = {
  name: routes.SUCCESS,
  path: `/${routes.SUCCESS}`,
};

export const EMBEDDED_ACCEPT_DISMISS_ROUTE = {
  path: `/${routes.EMBEDDED_ACCEPT_DISMISS}`,
};

export const REVIEW_INTRO_ROUTE = {
  name: routes.REVIEW_INTRO,
  path: `/${routes.REVIEW_INTRO}`,
};

export const REVIEW_NAME_ROUTE = {
  name: routes.REVIEW_NAME,
  path: `/${routes.REVIEW_NAME}`,
};

export const REVIEW_DOB_ROUTE = {
  name: routes.REVIEW_DOB_FIELD_PAGE,
  path: `/${routes.REVIEW_DOB_FIELD_PAGE}`,
};

export const REVIEW_ADDRESS_ROUTE = {
  name: routes.REVIEW_ADDRESS,
  path: `/${routes.REVIEW_ADDRESS}`,
};

export const REVIEW_SSN_ROUTE = {
  name: routes.REVIEW_SSN,
  path: `/${routes.REVIEW_SSN}`,
  isSubmitPage: true,
  runArkoseOnSubmit: true,
};

export const ALREADY_HAS_ACTIVE_ACCOUNT_ROUTE = {
  name: routes.ALREADY_HAS_ACTIVE_ACCOUNT,
  path: `/${routes.ALREADY_HAS_ACTIVE_ACCOUNT}`,
};

export const PREFILL_CONFIRMATION_ROUTE = {
  name: routes.PREFILL_CONFIRMATION,
  path: `/${routes.PREFILL_CONFIRMATION}`,
};
